module.exports = __webpack_public_path__ + "static/media/knowledge-test-hero-image.3eb7af75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/knowledge-test-hero-image.svg
// module id = 2044
// module chunks = 0